export class FormCompletedError extends Error {
  public override readonly name = 'FormCompletedError';

  constructor(
    message = 'La domanda è già stata inviata.',
    public override readonly cause?: unknown,
  ) {
    super(message);
  }
}
